import React from "react";
import { Button, Card, Popconfirm, Space, Table, Tag } from "antd";
import type { ColumnsType } from "antd/es/table";
import { SystemVersion } from "../../../../Api";

interface VersionHistoryTableProps {
  versions: SystemVersion[];
  current: SystemVersion | null;
  onEdit: (record: SystemVersion) => void;
  onDelete: (id: string) => void;
  formatDateTime: (value: string | null) => string;
}

export const VersionHistoryTable: React.FC<VersionHistoryTableProps> = ({
  versions,
  current,
  onEdit,
  onDelete,
  formatDateTime,
}) => {
  const columns: ColumnsType<SystemVersion> = [
    {
      title: "Version",
      dataIndex: "version",
      key: "version",
      render: (v: string, record) =>
        record.id === current?.id ? (
          <Tag color="blue">{v}</Tag>
        ) : (
          <span>{v}</span>
        ),
    },
    {
      title: "Notes",
      dataIndex: "notes",
      key: "notes",
      render: (n: string | null) => (
        <span className="whitespace-pre-wrap">{n || "—"}</span>
      ),
    },
    {
      title: "Migrated At",
      dataIndex: "migrated_at",
      key: "migrated_at",
      render: (v: string | null) => formatDateTime(v),
    },
    {
      title: "Seeded At",
      dataIndex: "seeded_at",
      key: "seeded_at",
      render: (v: string | null) => formatDateTime(v),
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "created_at",
      render: (v: string) => formatDateTime(v),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space>
          <Button size="small" onClick={() => onEdit(record)}>
            Edit
          </Button>
          <Popconfirm
            title="Delete this version?"
            onConfirm={() => onDelete(record.id)}
            okText="Delete"
            okButtonProps={{ danger: true }}
          >
            <Button size="small" danger>
              Delete
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <Card size="small" title="Version History">
      <Table
        rowKey="id"
        columns={columns}
        dataSource={versions}
        pagination={{ pageSize: 10 }}
        size="middle"
      />
    </Card>
  );
};
